export default __webpack_public_path__ + "static/media/bg-listed.7a4871f9.jpg";